var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBooksPieShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 570 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0c0c33;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{opacity:0.4;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 828.42,
    y1: 1024.38,
    x2: 1154.9,
    y2: 1024.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09b8fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2127a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 797.69,
    y1: 842.14,
    x2: 1149.15,
    y2: 842.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2127a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09b8fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 796.85,
    y1: 948.18,
    x2: 1159.33,
    y2: 948.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#feb30c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5005b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 936.76,
    y1: 1050.26,
    x2: 936.76,
    y2: 1098.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1070.31,
    y1: 1050.26,
    x2: 1070.31,
    y2: 1098.21,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BooksPie Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1154.9,1022.5a77.77,77.77,0,0,1-10.34,19.51,79.23,79.23,0,0,1-43,29.75,31.42,31.42,0,0,0-62.71,2.77H968.18a31.42,31.42,0,0,0-62.52-4.46,103.2,103.2,0,0,1-68.45-67.81l-8.79-28H885.7l4,12.77a46.88,46.88,0,0,0,44.71,32.81h147a23,23,0,0,0,3.73-45.66h.36C1128.26,974.34,1151.22,994,1154.9,1022.5Z",
    transform: "translate(-599.55 -737.45)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1159.33,896.72a77.26,77.26,0,0,1-18.4,50.11,77.47,77.47,0,0,0-55.8-27.42,23,23,0,0,0-3.4-45.65H854.1l10.2,32.47,4.23,13.44c-37.33,0-61.91-14.88-71.68-45.81a.54.54,0,0,0,0-.1l-17.17-54.64L778.36,815a32.74,32.74,0,0,0-31.23-22.92H727.38a27.32,27.32,0,1,1,0-54.64h28.79A75.07,75.07,0,0,1,827.78,790l9.15,29.11h244.8A77.69,77.69,0,0,1,1159.33,896.72Z",
    transform: "translate(-599.55 -737.45)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M779.65,819.12h0l17.17,54.64Z",
    transform: "translate(-599.55 -737.45)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1159.33,997a76,76,0,0,1-4.43,25.53c-3.69-28.59-26.77-48.27-69.77-48.27-1.13,0-2.26.08-3.4.08H828.42L796.85,873.86c9.77,30.93,34.35,45.81,71.68,45.81h213.2a22.39,22.39,0,0,0,3.4-.26,77.71,77.71,0,0,1,74.2,77.56Z",
    transform: "translate(-599.55 -737.45)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M936.76,1050.38a24.15,24.15,0,1,0,24.15,24.15A24.14,24.14,0,0,0,936.76,1050.38Zm0,33a8.82,8.82,0,1,1,8.81-8.81A8.81,8.81,0,0,1,936.76,1083.34Z",
    transform: "translate(-599.55 -737.45)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1070.31,1050.38a24.15,24.15,0,1,0,24.14,24.15A24.15,24.15,0,0,0,1070.31,1050.38Zm0,33a8.82,8.82,0,1,1,8.81-8.81A8.81,8.81,0,0,1,1070.31,1083.34Z",
    transform: "translate(-599.55 -737.45)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1144.56,1042c2.26-41.47-43.4-67.38-59.08-67.77,42.78.1,65.74,19.75,69.42,48.26A77.77,77.77,0,0,1,1144.56,1042Z",
    transform: "translate(-599.55 -737.45)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M868.53,919.67c-37.33,0-61.91-14.88-71.68-45.81,13.77,20.5,39.37,34,67.45,32.37h0Z",
    transform: "translate(-599.55 -737.45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooksPieShort);
export default __webpack_public_path__ + "static/media/BooksPie-short.4785f5ad37936563065cdb7056e1eb5e.svg";
export { ForwardRef as ReactComponent };